<template>
    <div class="">
        <!-- info modal -->
        <ElementsTooltipSingleton
            :ref="
                (el) => {
                    loadTooltipElementReady(el);
                }
            " />
        <!-- edit modal  -->
        <Teleport to="body">
            <AppPopup  v-model="showEditPopup" :name="modalTitle" max-width="640px">
                <div v-if="editItemsEmployeeStatus.employeeStatus == 'ON_LEAVE'">
                    <div class="p-6 pt-1">
                        <div class="flex justify-between items-center gap-0 mt-4">
                            <div class="c_label w-[8rem] mandatory horizon">
                                Leave Name
                            </div>
                            <DesignInput v-model="editItemsEmployeeStatus.leaveName"
                                :maxlength="60" :full="true" 
                                :error="editItemsEmployeeStatus.leaveNameErrorMessage"
                                class="flex-1"/>
                        </div>

                        <!-- Period  -->
                        <div class="flex justify-between items-center gap-0 mt-4">
                            <div class="c_label w-[8rem] mandatory horizon ">Period</div>
                            <div class="flex flex-col flex-1 gap-1">
                                <div class="flex items-center gap-3">
                                    <ElementsDatePicker
                                        v-model="editItemsEmployeeStatus.employeeStatusStartDatetime"
                                        placeholder="Start Date"
                                        :textLeft="true"
                                        :format="dateFormat"
                                        :wfull="true"
                                        :maxDate="editItemsEmployeeStatus.employeeStatusEndDatetime ? new Date(editItemsEmployeeStatus.employeeStatusEndDatetime) : null"
                                        :showErrorBorderOnly="editItemsEmployeeStatus.periodError"
                                    />
                                    <span class="font-body-md-regular text-content-basic-3">~</span>
                                    <ElementsDatePicker
                                        v-model="editItemsEmployeeStatus.employeeStatusEndDatetime"
                                        placeholder="End Date"
                                        :textLeft="true"
                                        :format="dateFormat"
                                        :wfull="true"
                                        :minDate="editItemsEmployeeStatus.employeeStatusStartDatetime ? new Date(editItemsEmployeeStatus.employeeStatusStartDatetime) : null"
                                        :showErrorBorderOnly="editItemsEmployeeStatus.periodError"
                                    />
                                </div>
                                <!-- 에러 메시지 -->
                                <div v-if="editItemsEmployeeStatus.periodError"
                                    class="c_alert_message mt-1">
                                    {{ editItemsEmployeeStatus.periodErrorMessage }}
                                </div>
                            </div>
                        </div>

                        <div class="flex justify-between items-center gap-0 mt-4">
                            <div class="c_label w-[8rem] mandatory horizon">Notes</div>
                            <DesignInput v-model="editItemsEmployeeStatus.employeeStatusContent"
                                        :maxlength="60" :full="true"
                                        :error="editItemsEmployeeStatus.notesErrorMessage"
                                        class="flex-1"/>
                        </div>
                        <div class="flex justify-between items-center gap-0 mt-4">
                            <div class="c_label w-[8rem] horizon">
                                PIC
                            </div>
                            <DesignInput v-model="editItemsEmployeeStatus.pic"
                                        :maxlength="60" :full="true"
                                        :disabled="true"
                                        :error="editItemsEmployeeStatus.notesErrorMessage"
                                        class="flex-1"/>
                        </div>
                    </div>

                    <!-- vacation edit button -->
                    <div class="flex w-full bg-white">
                        <div class="p-4 flex justify-end w-full bg-white gap-2 border-t-1 border-border-basic-2">
                            <DesignButton
                                @click="showEditPopup = false"
                                btnText="Cancel" btnSize="MD" btnType="SECONDARY" btnVariant="BORDER" class="w-[6rem]" :btnDisabled="false"
                            />
                            <DesignButton
                                @click="editSubmitRequestAfterConfirm(editItemsEmployeeStatus)"
                                btnText="Save" btnSize="MD" btnType="PRIMARY" btnVariant="FILL" class="w-[6rem]" :btnDisabled="false"
                            />
                        </div>
                    </div>
                </div>

                <div v-if="editItemsEmployeeStatus.employeeStatus == 'RESIGNED'">
                    <div class="pr-10 py-2 pl-7 flex flex-col gap-4">
                        <div class="grid grid-cols-5 items-center gap-1 pt-4 pb-[14px]">
                            <div class="w-40 text-sm font-medium text-[#555555] col-span-1">Resigned Date*</div>
                            <ElementsDatePicker v-model="editItemsEmployeeStatus.employeeResignationDate" placeholder="mm/dd/yyyy" :textLeft="true" :format="dateFormat" 
                                class="col-span-4 w-60" />
                        </div>
                        <div class="grid grid-cols-5 items-center gap-1 pt-4 pb-[14px]">
                            <div class="col-span-1 text-sm font-medium text-[#555555]">Resignation <br/> Type*</div>
                            <ElementsSelectRef 
                                v-model="editItemsEmployeeStatus.employeeResignationType" :options="resignationTypeOption" :width60="true" placeholder="Select Resignation Type" class="text-sm col-span-4"
                            />
                        </div>
                        <div class="grid grid-cols-5 items-start gap-1 pt-4 pb-[14px]">
                            <div class="col-span-1 w-40 text-sm font-medium text-[#555555]">Notes*</div>
                            <textarea
                                placeholder="Notes for internal communication"
                                class="col-span-4 h-[100px] w-full resize-none border-gray-300 border-[1px] rounded-lg py-[11px] text-sm"
                                v-model="editItemsEmployeeStatus.employeeStatusContent"
                                :maxlength="60">
                            </textarea>
                        </div>
                        <div class="grid grid-cols-5 items-start gap-1 pt-4 pb-[14px]">
                            <div class="col-span-1 w-40 text-sm font-medium text-[#555555]">
                                PIC
                            </div>
                            <ElementsInput v-model="editItemsEmployeeStatus.pic"
                                            :maxlength="60" :full="true"
                                            :disabled="true"
                                            :error="editItemsEmployeeStatus.notesErrorMessage"
                                            class="col-span-4"/>
                        </div>
                    </div>
                    <!-- 휴직 edit button -->
                    <div class="flex w-full bg-white">
                        <div class="w-full p-4 border-t bg-white-200">
                            <div class="text-right justify-end flex">
                                <ElementsButton text="Cancel"
                                                @click="showEditPopup = false"
                                                :width28="true" :height12="true" :background-white="true" />
                                <ElementsButton text="Save"
                                                @click="editSaveEmployeeResignation(editItemsEmployeeStatus)"
                                                :width28="true" :height12="true"
                                                class="ml-2"/>
                            </div>
                        </div>
                    </div>
                </div>
            </AppPopup>
            <ElementsModal2Button v-model="showDeleteCheckModal" :hasAlertIcon="true" modalTitle="Are you sure you want to delete this employee status?" buttonText="Confirm" btnColor="RED" modalContent="" @afterClick="deleteStatus()" />
        </Teleport>


        <!--Title START-->
        <div class="sticky top-0 w-[100%] pt-3 pb-4 bg-white" style="z-index:100">
            <div class="flex justify-between items-center">
                <h4 class="font-heading-sm-semibold">
                    Job Information
                </h4>
                <DesignButton
                    v-if="$appUtil.checkPermission('BASIC_INFO_EDIT') && showEditBtn"
                    v-show="!nowEdit"
                    btnText="Edit"
                    btnSize="SM"
                    btnType="PRIMARY"
                    btnVariant="BORDER"
                    :btnDisabled="false"
                    @click="editButtonClick"
                >
                    <template #front-icon>
                        <EditIcon :width="16" :height="16" color="text-primary-3" weight="REGULAR" />
                    </template>
                </DesignButton>
                <!-- <button v-if="$appUtil.checkPermission('BASIC_INFO_EDIT') && showEditBtn"
                        v-show="!nowEdit"
                        @click="editButtonClick"
                        class="border rounded-2 border-primary-3 w-20 h-[2.25rem] bg-white font-body-sm-medium text-primary-3 hover:bg-primary-1 transition-all duration-500 text-center">
                    Edit
                </button> -->
                <div class="flex justify-end items-center gap-2 " v-show="nowEdit">
                    <DesignButton
                        @click="cancelEditJobInfo"
                        btnText="Cancel" btnSize="SM" btnType="SECONDARY" btnVariant="BORDER" class="w-[64px]" :btnDisabled="false"
                    />
                    <DesignButton
                        @click="saveJobInfo"
                        btnText="Save" btnSize="SM" btnType="PRIMARY" btnVariant="FILL" class="w-[64px]" :btnDisabled="false"
                    />
                </div>
            </div>
            <p
                v-show="nowEdit"
                class="font-body-sm-regular text-accent-red-3"
            >
                You are in the editing mode now. Please click the save button.
            </p>
        </div>
        <!--Title END-->

        <!-- Employment Type-->
        <!-- HR 풀서비스 -->
        <div v-if="!isFlexbenOnly" class="flex justify-between items-center gap-2">
            <div class="c_label w-[8rem]">
                Employment Type
            </div>
            <DesignDropdownSelect 
                v-model="request.employmentType"
                placeholder="Employment Type"
                :options="employmentTypeOptions"
                :readonly="true"
                :error="requestError.employmentType"
                :width="'w-full'"
                class="flex-1"/>
        </div>

        <!-- FlexbenOnly 서비스 -->
        <div v-if="isFlexbenOnly" class="flex items-center gap-2 mt-4">
            <div class="c_label w-[8rem]">
                Employment Type
            </div>
            <DesignDropdownSelect
                v-model="request.employmentType"
                :options="employmentTypeOptions"
                :placeholder="'Employment Type'"
                :useDefaultMsg="true"
                :readonly="!nowEdit"
                :width="'w-full'"
                class="flex-1"
            />
        </div>

        <!-- Status-->
        <!-- HR 풀서비스 -->
        <div v-if="!isFlexbenOnly" class="flex items-center gap-2 mt-4">
            <div class="c_label w-[8rem]">Status</div>
            <StatusTag :statusCode="request.employeeStatus" />
            <ElementsDropDown
                :useArrowDown="true"
                :dropRight="true"
                :menuItems="[
                    { label: 'Inactive', action: () => clickVacationButton(), visible: true },
                    { label: 'Resigned', action: () => clickResignationButton(), visible: true },
                    { label: 'Account Delete', action: () => clickPermanentlyDeleteButton(), visible: request.employeeStatus == 'RESIGNED' },
                ]" />
        </div>

        <!-- FlexbenOnly 서비스 -->
        <div v-if="isFlexbenOnly" class="flex items-center gap-2 mt-4">
            <div class="c_label w-[8rem]">Status</div>
            <StatusTag :statusCode="request.employeeStatus" />
            <ElementsDropDown
                :useArrowDown="true"
                :dropRight="true"
                :menuItems="[
                    { label: 'Resigned', action: () => clickResignationButton(), visible: true },
                    { label: 'Account Delete', action: () => clickPermanentlyDeleteButton(), visible: request.employeeStatus == 'RESIGNED' },
                ]" />
        </div>


        <div class="mt-2 ml-[8.5rem]">
            <template v-for="(employeeStatusHistory, index) in employeeStatusHistoryList" :key="index">
                <div class="border border-border-basic-2 rounded-3 p-4 relative mt-2">
                    <div class="flex justify-between">
                        <p v-if="employeeStatusHistory.employeeStatus == 'ON_LEAVE'"
                            class="font-body-md-semibold">
                            {{ employeeStatusHistory.leaveName? employeeStatusHistory.leaveName : 'Inactive' }}
                        </p>
                        <p v-if="employeeStatusHistory.employeeStatus == 'RESIGNED'"
                            class="font-body-md-semibold">
                            Resigned
                        </p>
                        <ElementsDropDown
                            :menuItems="[
                                { label: 'Edit', action: () => clickEditButton(employeeStatusHistory), visible: true },
                                { label: 'Delete', action: () => clickDeleteButton(employeeStatusHistory), visible: true },
                            ]" />
                    </div>
                    <div v-if="employeeStatusHistory.employeeStatus == 'ON_LEAVE'" class="mt-1 font-body-sm-regular text-content-basic-2">
                        <div class="flex gap-1">
                            <div class="w-16 shrink-0">Period :</div>
                            <div class="flex-1">{{ moment(employeeStatusHistory.employeeStatusStartDatetime).format('MM/DD/YYYY') }}
                                ~ {{ moment(employeeStatusHistory.employeeStatusEndDatetime).format('MM/DD/YYYY') }}
                            </div>
                        </div>
                        <div class="flex gap-1">
                            <div class="w-16 shrink-0">Notes :</div>
                            <div class="flex-1">{{ employeeStatusHistory.employeeStatusContent }}</div>
                        </div>
                        <div class="flex gap-1">
                            <div class="w-16 shrink-0">PIC :</div>
                            <div class="flex-1">{{ $validateUtil.emptyValueToDash(employeeStatusHistory.pic) }}</div>
                        </div>
                    </div>
                    <div v-if="employeeStatusHistory.employeeStatus == 'RESIGNED'" class="mt-1 font-body-sm-regular text-content-basic-2">
                        <div class="flex gap-1">
                            <div class="w-16 shrink-0">Resigned Date :</div>
                            <div class="flex-1">{{ moment(employeeStatusHistory.employeeResignationDate).format('MM/DD/YYYY') }}</div>
                        </div>
                        <div class="flex gap-1">
                            <div class="w-44 shrink-0">Resignation Type :</div>
                            <div class="flex-1"> {{ displayResignationType(employeeStatusHistory.employeeResignationType) }}</div>
                        </div>
                        <div class="flex gap-1">
                            <div class="w-16 shrink-0">Notes :</div>
                            <div class="flex-1">{{ employeeStatusHistory.employeeStatusContent }}</div>
                        </div>
                        <div class="flex gap-1">
                            <div class="w-16 shrink-0">PIC :</div>
                            <div class="flex-1">{{ $validateUtil.emptyValueToDash(employeeStatusHistory.pic) }}</div>
                        </div>
                        
                    </div>
                </div>
            </template>
        </div>

        <!-- Employee ID-->
        <div class="flex justify-between items-center gap-2 mt-4">
            <div class="c_label w-[8rem]">
                Employee ID No.
            </div>
            <DesignInput
                v-model="request.employeeId"
                :disabled="!nowEdit" :maxlength="20" :full="true" :error="requestError.employeeId"
                class="flex-1"
            />
        </div>


        <!-- Office-->
        <div class="flex justify-between items-center gap-2 mt-4">
            <div class="c_label w-[8rem]">
                Office
            </div>
            <DesignDropdownSelect v-model="request.workPlaceSeq"
                placeholder="Select Office"
                :options="workPlaceOptions"
                size="LG"
                :width="'w-60'"
                :useDefaultMsg="true"
                :readonly="!nowEdit"
                :error="requestError.officeSeq"
                class="flex-1"/>
        </div>
        <div class="flex items-center gap-2 mt-4">
            <div class="flex gap-1 items-center c_label w-[8rem]">
                <span>Department</span>
                <InformationCircleIcon
                    class="h-5 w-5 text-primary-3"
                    aria-hidden="true"
                    :ref="
                        (el) => {
                            loadTooltip(el, () => {
                                return 'Tick the head button if you want to set it as a header of this department. \
                        <br/>Only one header can be set in each department.';
                            });
                        }
                    " />
            </div>
            <DesignDropdownSelect
                v-model="request.departmentSeq"
                placeholder="Select Department"
                class="flex-1 max-w-[14rem] mr-4"
                size="LG"
                :width="'w-60'"
                :useDefaultMsg="true"
                :readonly="!nowEdit"
                :options="departmentOptions"
                :error="requestError.departmentSeq"
                @change="resetHeadCheckbox" />
            <ElementsCheckbox v-if="!isResigned" v-model="isHeadOfOrganition" :text="'Head'" :disabled="!nowEdit" @change="checkDuplicateHead" />
        </div>

        <div class="flex justify-between items-center gap-2 mt-4">
            <div class="c_label w-[8rem]">
                Tier
            </div>
            <DesignDropdownSelect v-model="request.jobTitleSeq"
                placeholder="Select Role"
                :readonly="!nowEdit"
                size="LG"
                :width="'w-60'"
                :useDefaultMsg="true"
                :options="jobTitleOptions"
                :error="requestError.jobTitleSeq"
                class="flex-1 w-[20rem]"/>
        </div>


        <div v-if="!$appUtil.checkSubscription('FLEXBEN_ONLY_USAGE')" class="flex justify-between gap-2 mt-4">
            <div class="c_label w-[8rem] h-[2.75rem] flex items-center">
                Work Schedule
            </div>
            <template v-if="workSchedule.name">
                <div class="flex-1 flex justify-between gap-2">
                    <div class="border border-border-basic-2 rounded-2 px-4 py-3">
                        <designReadOnlyTag v-if="workSchedule?.workScheduleType == 'FLEXI_TIME'" 
                            tagType="SOLID" tagSize="S" tagColor="VIOLET" tagText="Flexi schedule">
                            <template v-slot:front-icon>
                                <flexiIcon width="12" height="12" color="text-content-inverse-1" />
                            </template>
                        </designReadOnlyTag>
                        <h4 class="font-body-sm-semibold">
                            {{ workSchedule.name }}
                        </h4>
                        <template v-if="['FIXED_TIME', 'SHIFT_TIME'].includes(workSchedule.workScheduleType)">
                            <div class="mt-1">
                                <div class="flex items-center gap-1 cursor-pointer">
                                    <div class="font-caption-md-regular text-content-basic-2">
                                        {{ workSchedule.workDay }}
                                    </div>
                                </div>
                            </div>
                            <div v-for="(time, idx) in workSchedule.workingTime" :key="idx" 
                                class="font-caption-md-regular text-content-basic-2"> 
                                {{ time }}
                            </div>
                            <p 
                                class="font-caption-md-regular text-content-basic-2">
                                {{ workSchedule.workTime.hours }} hours {{ workSchedule.workTime.minutes }} minutes in a day
                            </p>
                        </template>
                        <template v-else>
                            <div class="mt-1">
                                <div class="font-caption-md-regular text-content-basic-2">
                                    Work Window
                                </div>
                                <ul class="pl-5  list-disc font-caption-md-regular text-content-basic-2">
                                    <li>{{ workSchedule.workDay }}</li>
                                    <li v-for="(time, idx) in workSchedule.workingTime" :key="idx" >
                                        {{ time }}
                                    </li>
                                </ul>
                            </div>
                            <p class="font-caption-md-regular text-content-basic-2">
                                Daily Max {{ formatDuration(workSchedule.dailyMaxMinutes) }}
                            </p>
                            <p class="font-caption-md-regular text-content-basic-2">
                                Weekly Target {{ formatDuration(workSchedule.weeklyTargetMinutes) }}
                            </p>
                        </template>
                    </div>
                </div>
            </template>

            <template v-else>
                <div class="flex-1 flex justify-between gap-2">
                    <div class="border border-border-basic-2 rounded-2 px-4 py-3">
                        <div class="text-center">
                            <h3 class="font-body-sm-semibold">
                                No schedule
                            </h3>
                            <p class="font-caption-md-regular text-content-basic-2">
                                This employee is not applied in any schedule.
                            </p>
                        </div>
                    </div>
                </div>
            </template>

        </div>


        <div class="flex justify-between gap-2 mt-4">
            <div class="c_label w-[8rem] h-[2.75rem] flex items-center">
                Join date
            </div>
            <div class="flex-1">
                <ElementsDatePicker v-model="request.joinDate"
                                    @changeDate="getPeriodFromJoined"
                                    :disabled="!nowEdit"
                                    :full="true" :error="requestError.joinDate" :hasBorder="true"/>

                <div v-if="!nowEdit && request.joinDate"
                    class="mt-2 flex items-center gap-1">
                    <img src="@/assets/img/tab-job-info-1.svg" alt="tab-job-info-1"/>
                    <p class="font-body-sm-regular text-content-basic-2">
                        {{ period.diffYear }} years {{ period.diffMonth }} months {{ period.diffDay }} days
                    </p>
                </div>

                <div v-if="!$appUtil.checkSubscription('FLEXBEN_ONLY_USAGE')" v-show="nowEdit" class="mt-2 flex items-start gap-1" >
                    <img src="@/assets/img/tab-job-info-2.svg" alt="tab-job-info-2" />
                    <p class="font-body-sm-regular text-content-basic-2">
                        This may affect employee's workday settings in Time and Leave.<br />
                        Employee's upcoming leaves might have inaccurate duration as they<br />
                        follow previous workday settings.
                    </p>
                </div>
            </div>
        </div>

        <div v-if="request.employeeType == 'PROBATION'" class="flex justify-between items-center gap-2 mt-6">
            <div class="w-32 text-sm font-semibold text-slate-800">
                End date of probationary period
            </div>
            <ElementsDatePicker v-model="request.endDateOfProbationaryPeriod"
                                placeholder="MM/DD/YYYY"
                                class="flex-1"
                                :disabled="!nowEdit"
                                :full="true" :error="requestError.endDateOfProbationaryPeriod" />
        </div>

        <ElementsNotification v-model="showNoti" />
        <ElementsNotification v-model="showNotiErr"
                            :notificationMsg="'Please check the error message'" :warning="true" />



        <Teleport to="body">
            <!-- add vacation -->
            <AppPopup v-model="showVacationView" name="Indefinite Leave" maxWidth="640px">
                <div class="p-4 flex flex-col gap-4">
                    <div class="flex gap-2">
                        <label class="c_label mandatory w-[8rem] h-[2.75rem] flex items-center gap-1 shrink-0">
                            Leave Name
                        </label>
                        <DesignInput v-model="popupItems.leaveName"
                                    :maxlength="60"
                                    :error="popupItems.leaveNameErrorMessage"
                                    class="flex-1"/>
                    </div>
                    <div class="flex gap-2">
                        <label class="c_label mandatory w-[8rem] h-[2.75rem] flex items-center gap-1 shrink-0">
                            Period
                        </label>
                        <div class="flex flex-col flex-1 gap-3 w-full">
                            <div class="flex items-center gap-2 w-full">
                                <ElementsDatePicker
                                    v-model="popupItems.employeeStatusStartDatetime"
                                    placeholder="Start Date"
                                    :textLeft="true"
                                    :format="dateFormat"
                                    :wfull="false"
                                    :maxDate="popupItems.employeeStatusEndDatetime ? new Date(popupItems.employeeStatusEndDatetime) : null"
                                    :showErrorBorderOnly="popupItems.periodError"
                                />
                                <span class="font-body-md-regular text-content-basic-3">~</span>
                                <ElementsDatePicker
                                    v-model="popupItems.employeeStatusEndDatetime"
                                    placeholder="End Date"
                                    :textLeft="true"
                                    :format="dateFormat"
                                    :wfull="false"
                                    :minDate="popupItems.employeeStatusStartDatetime ? new Date(popupItems.employeeStatusStartDatetime) : null"
                                    :showErrorBorderOnly="popupItems.periodError"
                                />
                            </div>
    
                            <!-- 에러 메시지 -->
                            <div v-if="popupItems.periodError"
                                class="mt-1 c_alert_message">
                                {{ popupItems.periodErrorMessage }}
                            </div>
                        </div>
                    </div>

                    <div class="flex gap-2">
                        <label class="c_label mandatory w-[8rem] h-[2.75rem] flex items-center gap-1 shrink-0">
                            Notes
                        </label>
                        <DesignInput v-model="popupItems.employeeStatusContent"
                                    :maxlength="60" :full="true"
                                    :error="popupItems.notesErrorMessage"
                                    class="flex-1"/>
                    </div>
                </div>

                <!-- add button -->
                <div class="sticky bottom-0">
                    <div class="p-4 flex justify-end w-full bg-white gap-2 border-t-1 border-border-basic-2">
                        <DesignButton
                            class="w-[5rem]"
                            @click="showVacationView = false"
                            btnText="Cancel" btnSize="MD" btnType="SECONDARY" btnVariant="BORDER" :btnDisabled="false"
                        />
                        <DesignButton
                            class="w-[5rem]"
                            @click="addVacationSubmitRequestAfterConfirm()"
                            btnText="Save" btnSize="MD" btnType="PRIMARY" :btnDisabled="false"
                        />
                    </div>
                </div>
            </AppPopup>

            <!-- add resignation -->
            <AppPopup v-model="showResignationView" name="Resigned" tooltip="If change status to resigned, this employee can’t log in."  maxWidth="640px">
                <div class="p-4 flex flex-col gap-4">
                    <div class="flex gap-2">
                        <label class="c_label mandatory w-[8rem] h-[2.75rem] flex items-center gap-1 shrink-0">
                            Resigned Date
                        </label>
                        <ElementsDatePicker v-model="popupItems.employeeResignationDate" placeholder="mm/dd/yyyy" :textLeft="true" :format="dateFormat" class="w-full"/>
                    </div>

                    <div class="flex gap-2">
                        <label class="c_label mandatory w-[8rem] h-[2.75rem] flex items-center gap-1 shrink-0">
                            Resignation Type
                        </label>
                        <DesignDropdownSelect
                            v-model="popupItems.employeeResignationType" 
                            :options="resignationTypeOption" 
                            placeholder="Select Resignation Type" 
                            :width="'w-full'"
                            class="flex-1"
                        />
                    </div>


                    <div class="flex gap-2">
                        <label class="c_label mandatory w-[8rem] h-[2.75rem] flex items-center gap-1 shrink-0">
                            Notes
                        </label>
                        <textarea
                            placeholder="Notes for internal communication"
                            class="h-[10rem] w-full resize-none border-border-basic-2 border-[1px] rounded-2 py-[.875rem] font-body-sm-regular"
                            v-model="popupItems.employeeStatusContent"
                            :maxlength="60">
                        </textarea>
                    </div>
                </div>

                <!-- add button -->
                <div class="sticky bottom-0">
                    <div class="p-4 flex justify-end w-full bg-white gap-2 border-t-1 border-border-basic-2">
                        <DesignButton
                            class="w-[5rem]"
                            @click="showResignationView = false"
                            btnText="Cancel" btnSize="MD" btnType="SECONDARY" btnVariant="BORDER" :btnDisabled="false"
                        />
                        <DesignButton
                            class="w-[5rem]"
                            @click="resignedDuplicationCheck"
                            btnText="Submit" btnSize="MD" btnType="PRIMARY" :btnDisabled="false"
                        />
                    </div>
                </div>
            </AppPopup>
            
            <DeletePopup 
                v-model="showDeleteEmployeeCheckPopup"
                title="Delete Confirmation"
                content="Deleting this account will remove all information from the system and cannot be undone. Would you like to proceed?"
                checkboxText="I understand and want to delete this account."
                @button-event="deleteAccount" 
            />

            <ConfirmPopup
                v-model="showHeadCheckPopup"
                confirmDescription="This department already has a head assigned. Please remove the current Head to assign a new one."
                buttonText="OK"
                :isBold="false"
                :isTextLg="true" />
        </Teleport>
    </div>
</template>

<script>
import { status, contractType } from '@/assets/data/optionData.js';
import { ValidateUtil } from '@/plugins/app-util.js';
import { InformationCircleIcon } from '@heroicons/vue/outline';
import ElementsTooltipSingleton from '@/components/elements/ElementsTooltipSingleton.vue';
import ConfirmPopup from '@/components/ConfirmPopup.vue';
import StatusTag from '@/components/employee/status-tag/employee-status-tag.vue';
import ElementsDropDown from '@/components/elements/ElementsDropdown.vue';
import DesignDropdownSelect from '@/components/design-system/design-dropdown-select.vue';
import downArrow from '@/assets/img/downArrow.svg';
import moment from 'moment';
import DeletePopup from '@/components/DeletePopup.vue';
import DesignInput from '@/components/design-system/design-input.vue';
import DesignButton from '@/components/design-system/design-button.vue';
import EditIcon from '@/components/design-system/icon/edit.vue';
import designReadOnlyTag from '@/components/design-system/design-read-only-tag.vue';
import flexiIcon from '@/components/design-system/icon/flexi.vue';

export default {
    components: {
        InformationCircleIcon,
        ElementsTooltipSingleton,
        ConfirmPopup,
        StatusTag,
        ElementsDropDown,
        DesignDropdownSelect,
        DeletePopup,
        DesignInput,
        DesignButton,
        EditIcon,
        designReadOnlyTag,
        flexiIcon,
    },
    props: {
        selectedEmployeeSeq: String,
        employeeStatusHistoryList: Array,
    },
    emits: ['afterSave', 'getHistory', 'editing-change'],
    watch: {
        hasChange(val) {
            this.$emit('editing-change', val);
        },
    },
    data() {
        return {
            downArrow: downArrow, // drop down img
            dateValue: null,
            activeEmployee: false,
            dateFormat: 'YYYY-MM-DDTHH:mm:ss.sssZ',
            employeeStatus: null,
            modalTitle: null,
            contractInfoEmployeeList: [],
            employeeStatusList: [],
            resignationTypeOption: [
                {value: 'T', text: "Terminated/Resigned"},
                {value: 'TR', text: "Transferred"},
                {value: 'R', text: "Retirement"},
                {value: 'D', text: "Death"},
            ],
            employeeStatusHistorySeq: null,
            currentDepartmentSeq: null,
            isCurrentHead: false,
            showHeadCheckPopup: false,
            showDeleteCheckModal: false,
            showEditPopup: false,
            // employeeStatusHistoryList: null,
            showNoti: false,
            showNotiErr: false,
            nowEdit: false,
            showEditBtn: false,
            showVacationView: false,
            showResignationView: false,
            showDeleteEmployeeCheckPopup: false,
            isDeleteEmployeeChecked: false,
            disableDeleteButton: true,
            workPlaceOptions: [],
            departmentOptions: [],
            jobTitleOptions: [],
            employmentTypeOptions: contractType,
            statusOptions: status,
            lastWorkingDate: null,
            period: {
                diffYear: null,
                diffMonth: null,
                diffDay: null,
            },
            beforeEditData: {},
            workSchedule: {
                name: null,
                startTime: null,
                endTime: null,
                workTime: {hours: null, minutes: null},
                workDay: null,
                shiftList: null,
            },
            request: {
                employeeSeq: this.selectedEmployeeSeq,
                workPlaceSeq: null,
                departmentSeq: null,
                jobTitleSeq: null,
                joinDate: null,
                employeeStatus: null,
                departmentManagerEmployeeSeq: null,
                employeeId: null,
            },
            requestError: {
                departmentSeq: null,
                jobTitleSeq: null,
                workSchedule: null,
                joinDate: null,
                endDateOfProbationaryPeriod: null,
                employeeStatus: null,
                employeeId: null,
            },
            requestErrorMSG: {
                departmentSeq: 'Please select Department.',
                jobTitleSeq: 'The JobTitle should be selected',
                workSchedule: 'The WorkSchedule should be selected',
                joinDate: 'JoinDate should be selected',
                endDateOfProbationaryPeriod: '',
                employeeStatus: 'Employee status should be selected',
                employeeId: '',
            },
            isHeadOfOrganition: false,
            editItemsEmployeeStatus: {
                employeeSeq: null,
                employeeStatus: null,
                employeeStatusContent: null,
                employeeStatusStartDatetime: null,
                employeeStatusEndDatetime: null,
                employeeResignationDate: null,
                employeeResignationType: null,
                leaveName: null,
                leaveNameError: false,
                leaveNameErrorMessage: '',
                periodError: false,
                periodErrorMessage: '',
                notesError: false,
                notesErrorMessage: '',
                pic: null
            },
            popupItems: {
                employeeSeq: null,
                employeeStatus: null,
                employeeStatusContent: null,
                employeeStatusStartDatetime: null,
                employeeStatusEndDatetime: null,
                employeeResignationDate: null,
                employeeResignationType: null,
                leaveName: null,
                leaveNameBlankError: false,
                leaveNameLengthError: false,
                periodBlankError: false,
                periodInvalidPeriodError: false,
                notesBlankError: false,
                notesLengthError: false,
                pic: sessionStorage.getItem("pic")
            },
        }; // return
    }, //data
    computed: {
        isResigned() {
            return this.request.employeeStatus === 'RESIGNED';
        },
        isFlexbenOnly() {
            return this.$appUtil.checkSubscription('FLEXBEN_ONLY_USAGE');
        },
        hasChange() {
            if (!this.nowEdit) return false;
            return JSON.stringify(this.request) !== JSON.stringify(this.beforeEditData);
        },
    },
    async mounted() {
        const self = this;
        console.log("pic", self.popupItems.pic)

        try {
            const departmentUrl = self.$api('uri', 'get-department');
            const departmentQuery = JSON.stringify({showRootNode: true, menuAccessLevelCode: 'TEAM_ACCESS_LEVEL'});
            const departmentRes = await self.$axios.get(departmentUrl, {params: {json_query: departmentQuery}});
            self.departmentOptions = departmentRes.data.data.list.map((dep) => ({
                text: dep.departmentName,
                value: dep.departmentSeq,
            }));

            const jobTitleUrl = self.$api('uri', 'get-jobTitle');
            const jobTitleQuery = JSON.stringify({limit: -1, offset: 0});
            const jobTitleRes = await self.$axios.get(jobTitleUrl, {params: {json_query: jobTitleQuery}});
            self.jobTitleOptions = jobTitleRes.data.data.list.map((job) => ({
                text: job.jobTitleName,
                value: job.jobTitleSeq,
            }));

            const workPlaceUrl = self.$api('uri', 'get-work-place');
            const workPlaceRes = await self.$axios.get(workPlaceUrl);
            const workPlaceList = workPlaceRes.data.data.list;
            self.workPlaceOptions = workPlaceList.map((place) => ({
                text: place.workPlaceName,
                value: place.workPlaceSeq,
            }));

            // 모든 API 호출이 완료된 후에 함수 호출
            self.getEmployeeJobInfo(self.selectedEmployeeSeq);
            self.getEmployeeStatusHistoryData(self.selectedEmployeeSeq);
            self.getContractInfoEmployeeList(self.selectedEmployeeSeq);
            self.$emit('getHistory');
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    },
    methods: {
        moment: moment,
        // -----------------------------------------------------------------------------
        loadTooltip(ele, msgFn, options) {
            this.__tooltipComponent__hidden__.loadBasic(ele, msgFn, options);
        },
        loadTooltipElementReady(ele) {
            if (ele == null) return; // auto-reload, so element can be null sometime.
            this.__tooltipComponent__hidden__ = ele;
        },
        // -----------------------------------------------------------------------------
        changeDate(date) {
            const now = new Date();
            const formatter = new Intl.DateTimeFormat('fr-CA', {year: 'numeric', month: 'numeric', day: 'numeric'});
            const dateString = formatter.format(date).replace(/-/g, '');
            return dateString;
        },
        allClose() {
            const self = this;
            self.showEditPopup = false;
            self.showVacationView = false;
            self.showDeleteCheckModal = false;
            self.showDeleteEmployeeCheckPopup = false;
            self.showResignationView = false;
        },
        parseInt: parseInt,
        changeDateFormat(dateItem) {
            const changeDate = moment(dateItem).format('MM/DD/YYYY');
            return changeDate;
        },
        getContractInfoEmployeeList(userSeq) {
            const self = this;

            const url = self.$api('uri', `get-employee-contract-info-history-one`).replace('{employeeSeq}', encodeURIComponent(userSeq));
            self.$axios
                .get(url)
                .then((res) => {
                    self.contractInfoEmployeeList = res.data.data.list;

                    if (self.contractInfoEmployeeList.length != 0) {
                        self.dateValue = self.contractInfoEmployeeList[0].employeeContractInfoStartDatetime;
                    }
                })
                .catch((err) => {
                    console.error('err : ', err);
                });
        },
        isWithin30Days(date) {
            const today = new Date();
            const diff = today.getTime() - new Date(date).getTime(); // date를 new Date()로 변환하여 차이를 계산
            const diffInDays = diff / (1000 * 60 * 60 * 24); // 밀리초를 일(day) 단위로 변환
            return diffInDays <= 30;
        },
        //vacation 만 중복 체크 한다
        editSubmitRequestAfterConfirm(editItemsEmployeeStatus) {
            const self = this;
            if (!self.isEmployeeStatusValid(editItemsEmployeeStatus)) {
                return;
            }

            const employeeStatusHistorySeq = self.editItemsEmployeeStatus.employeeStatusHistorySeq;
            const startDate = self.editItemsEmployeeStatus.employeeStatusStartDatetime;
            const endDate = self.editItemsEmployeeStatus.employeeStatusEndDatetime;
            const employeeSeq = self.selectedEmployeeSeq;

            const requestItem = {startDate, endDate, employeeSeq};
            // duplication check
            const url = self.$api('uri', 'post-check-period-duplication');
            self.$axios
                .post(url, requestItem)
                .then((res) => {
                    // 현재 seq는 제외하고 중복체크
                    let dupList = res.data.data.list.filter(
                        item => item.employeeStatusHistorySeq !== employeeStatusHistorySeq
                    );

                    if (dupList == null || dupList.length == 0) {
                        self.editSaveEmployeeVacation(editItemsEmployeeStatus);
                    } else {
                        alert('Date already has vacation.');
                    }
                })
                .catch((err) => {
                    console.log('fail: ', err);
                });
        },
        editSaveEmployeeVacation(editItemsEmployeeStatus) {
            const self = this;

            //init
            let {
                employeeSeq,
                employeeStatus,
                employeeStatusHistorySeq,
                employeeStatusContent,
                employeeStatusStartDatetime,
                employeeStatusEndDatetime,
                leaveName
            } = '';

            employeeSeq = editItemsEmployeeStatus.employeeSeq;
            employeeStatusHistorySeq = editItemsEmployeeStatus.employeeStatusHistorySeq;

            employeeStatus = 'ON_LEAVE';
            employeeStatusContent = ValidateUtil.checkIsEmptyChangeSpace(self.editItemsEmployeeStatus.employeeStatusContent);
            employeeStatusStartDatetime = self.editItemsEmployeeStatus.employeeStatusStartDatetime;
            employeeStatusEndDatetime = self.editItemsEmployeeStatus.employeeStatusEndDatetime;
            leaveName = self.editItemsEmployeeStatus.leaveName;

            var requestItem = {
                employeeSeq,
                employeeStatus,
                employeeStatusHistorySeq,
                employeeStatusContent,
                employeeStatusStartDatetime,
                employeeStatusEndDatetime,
                leaveName,
            };

            if (self.showEditPopup) {
                self.showEditPopup = false;
            } else {
                self.showEditPopup = true;
            }
            self.showEditPopup = false;

            const url = self.$api('uri', 'put-employee-status-history');
            self.$axios
                .put(`${url}/${encodeURIComponent(self.employeeStatusHistorySeq)}`, requestItem)
                .then((res) => {
                    console.log(res);
                    self.getEmployeeJobInfo(self.selectedEmployeeSeq);
                    self.getEmployeeStatusHistoryData(self.selectedEmployeeSeq);
                    self.$emit('afterSave');
                    self.$emit('getHistory');
                })
                .catch((err) => {
                    console.log(err.response);
                });
        },
        editSaveEmployeeResignation(editItemsEmployeeStatus) {
            const self = this;

            //init
            let employeeSeq = editItemsEmployeeStatus.employeeSeq;
            let employeeStatusHistorySeq = editItemsEmployeeStatus.employeeStatusHistorySeq;
            let employeeStatus = 'RESIGNED';

            let employeeStatusContent = ValidateUtil.checkIsEmptyChangeSpace(editItemsEmployeeStatus.employeeStatusContent);
            let employeeResignationDate = editItemsEmployeeStatus.employeeResignationDate;
            let employeeResignationType = editItemsEmployeeStatus.employeeResignationType;

            if (employeeResignationDate == null) {
                console.log('Please enter a Resigned date');
                alert('Please enter a valid Resigned date');
                return;
            }

            if (ValidateUtil.checkIsEmpty(employeeStatusContent)) {
                alert('Notes can’t be blank');
                return;
            }

            if (ValidateUtil.checkIsEmpty(employeeResignationType)) {
                alert('Resignation Type can’t be blank');
                return;
            }

            var requestItem = {
                employeeSeq,
                employeeStatus,
                employeeStatusHistorySeq,
                employeeStatusContent,
                employeeResignationDate,
                employeeResignationType,
            };

            const url = self.$api('uri', 'put-employee-status-history');
            self.$axios
                .put(`${url}/${encodeURIComponent(self.employeeStatusHistorySeq)}`, requestItem)
                .then((res) => {
                    self.showEditPopup = false;
                    console.log(res);
                    self.getEmployeeJobInfo(self.selectedEmployeeSeq);
                    self.getEmployeeStatusHistoryData(self.selectedEmployeeSeq);
                    self.$emit('afterSave');
                    self.$emit('getHistory');
                })
                .catch((err) => {
                    console.log(err.response);
                });
        },
        changeDateType(dateString) {
            if (dateString == null) {
                return null;
            } else {
                dateString = new Date(dateString);
                return dateString;
            }
        },
        clickDeleteButton(employeeStatusHistory) {
            if (employeeStatusHistory.isShow) {
                employeeStatusHistory.isShow = false;
            } else {
                employeeStatusHistory.isShow = true;
            }

            const self = this;
            self.showDeleteCheckModal = true;
            self.employeeStatusHistorySeq = employeeStatusHistory.employeeStatusHistorySeq;
        },
        //데이터 삭제
        deleteStatus() {
            const self = this;
            const employeeStatusHistorySeq = self.employeeStatusHistorySeq;
            const url = self.$api('uri', 'delete-employee-status-history');

            var requestItem = {employeeStatusHistorySeq};

            self.$axios
                .delete(`${url}/${encodeURIComponent(employeeStatusHistorySeq)}`, requestItem)
                .then((res) => {
                    console.log(res);
                    self.showDeleteCheckModal = false;

                    self.getEmployeeJobInfo(self.selectedEmployeeSeq);
                    self.getEmployeeStatusHistoryData(self.selectedEmployeeSeq);
                    self.$emit('afterSave');
                    self.$emit('getHistory');
                })
                .catch(console.log);
        },
        //open Modal
        clickEditButton(employeeStatusHistory) {
            const self = this;
            self.showEditPopup = true;

            if (employeeStatusHistory.employeeStatus == 'RESIGNED') {
                self.modalTitle = 'Resigned';
            } else {
                self.modalTitle = 'Indefinite Leave';
            }

            employeeStatusHistory.isShow = !employeeStatusHistory.isShow;

            //init
            self.editItemsEmployeeStatus.contractInfoContent = '';
            self.editItemsEmployeeStatus.employmentType = '';
            self.editItemsEmployeeStatus.employeeContractInfoStartDatetime = '';
            self.editItemsEmployeeStatus.employeeContractInfoEndDatetime = '';
            self.editItemsEmployeeStatus.employeeResignationDate = '';
            self.editItemsEmployeeStatus.employeeResignationType = '';
            self.editItemsEmployeeStatus.leaveName = '';
            self.editItemsEmployeeStatus.pic = '';

            self.beforeEditData = {...employeeStatusHistory};
            self.editItemsEmployeeStatus = self.beforeEditData;
            self.employeeStatusHistorySeq = self.editItemsEmployeeStatus.employeeStatusHistorySeq;
        },
        getEmployeeStatusHistoryData(userSeq) {
            const self = this;
            //init
            self.employeeStatusList = {};
            const url = self.$api('uri', `get-employee-status-history`).replace('{employeeSeq}', encodeURIComponent(userSeq));
            self.$axios
                .get(url)
                .then((res) => {
                    self.employeeStatusList = res.data.data.list;
                    if (self.employeeStatusList != null) {
                        const dbStartDate = self.employeeStatusList.employeeStatusStartDatetime;
                        const dbEndDate = self.employeeStatusList.employeeStatusEndDatetime;
                        const dbResignationDate = self.employeeStatusList.employeeResignationDate;
                        const today = new Date();
                        const todayTime = today.getTime();

                        if (dbStartDate != null) {
                            //휴직 날짜 비교
                            const dbStartDateObj = self.changeDateType(dbStartDate);
                            const dbEndDateObj = self.changeDateType(dbEndDate);

                            if (dbStartDateObj.getTime() >= todayTime) {
                                if (dbEndDateObj.getTime() < todayTime) {
                                    self.employeeStatus = self.employeeStatusList.employeeStatus;
                                }
                            } else {
                                // 현재 날짜가 DB에서 가져온 날짜보다 작을 때 - 아직
                            }
                        } else if (dbResignationDate != null) {
                            // 퇴직 날짜 비교
                            const dbResignationDateObj = self.changeDateType(dbResignationDate);
                            if (dbResignationDateObj.getTime() >= todayTime) {
                                self.employeeStatus = self.employeeStatusList.employeeStatus;
                            } else {
                                // 현재 날짜가 DB에서 가져온 날짜보다 작을 때 - 아직
                            }
                        }
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        resetScheduleData() {
            return {
                name: null,
                startTime: null,
                endTime: null,
                workTime: {hours: null, minutes: null},
                workDay: null,
                shiftList: null,
            };
        },
        isValidCheck() {
            const self = this;
            let isValid = true;

            if (ValidateUtil.checkIsEmpty(self.request.joinDate)) {
                self.requestError.joinDate = self.requestErrorMSG.joinDate;
                isValid = false;
            }

            if (ValidateUtil.checkIsEmpty(self.request.departmentSeq)) {
                self.requestError.departmentSeq = self.requestErrorMSG.departmentSeq;
                isValid = false;
            }
            return isValid;
        },
        isEmployeeStatusValid(request) {
            // 유효성 검사 결과 상태 초기화
            [
                'leaveNameError',
                'periodError',
                'notesError'
            ].forEach(key => request[key] = false);

            [
                'leaveNameErrorMessage',
                'periodErrorMessage',
                'notesErrorMessage'
            ].forEach(key => request[key] = '');

            const {leaveName, employeeStatusStartDatetime, employeeStatusEndDatetime, employeeStatusContent} = request;

            if (ValidateUtil.checkIsEmpty(leaveName)) {
                request.leaveNameError = true;
                request.leaveNameErrorMessage = 'Please enter a leave name.';
            }
            if (leaveName && leaveName.length > 50) {
                request.leaveNameError = true;
                request.leaveNameErrorMessage = 'Please keep the leave name within 50 characters.';
            }

            if (ValidateUtil.checkIsEmpty(employeeStatusStartDatetime) || ValidateUtil.checkIsEmpty(employeeStatusEndDatetime)) {
                request.periodError = true;
                request.periodErrorMessage = 'Please select a start and end date.';
            }

            if (ValidateUtil.checkIsEmpty(employeeStatusContent)) {
                request.notesError = true;
                request.notesErrorMessage = 'Please enter a notes.';
            }
            if (employeeStatusContent && employeeStatusContent.length > 50) {
                request.notesError = true;
                request.notesErrorMessage = 'Please keep the notes within 50 characters.';
            }

            // If any error exists, return false
            if (request.leaveNameError || request.periodError || request.notesError) {
                return false;
            }
            return true;
        },
        errMsgReset() {
            const self = this;
            for (let errMsgKey in self.requestError) {
                self.requestError[errMsgKey] = '';
            }
        },
        getEmployeeJobInfo(userSeq) {
            const self = this;

            self.workSchedule = self.resetScheduleData();
            const url = self.$api('uri', `get-employee-job-info`).replace('{employeeSeq}', encodeURIComponent(userSeq));
            self.$axios
                .get(url)
                .then((res) => {
                    self.request = {...res.data.data};

                    if (self.request.employeeStatus == 'ACTIVE') {
                        self.activeEmployee = true;
                    }

                    self.isHeadOfOrganition = false;
                    if (self.request.departmentManagerEmployeeSeq != null) {
                        if (userSeq == self.request.departmentManagerEmployeeSeq) {
                            self.isHeadOfOrganition = true;
                            self.isCurrentHead = true;
                        }
                    }

                    if (res.data.data.workScheduleSeq) {
                        self.getScheduleData(res.data.data.workSchedule);
                    }

                    if (res.data.data.resignInformation) {
                        self.lastWorkingDate = res.data.data.resignInformation.resignationDate;
                    }

                    if (res.data.data.joinDate) {
                        self.getPeriodFromJoined(res.data.data.joinDate);
                    }
                    self.showEditBtn = true;
                    self.currentDepartmentSeq = res.data.data.departmentSeq;
                })
                .catch((err) => (self.showEditBtn = false));
        },
        getScheduleData(schedule) {
            const self = this;
            self.workSchedule.workScheduleType = schedule.workScheduleType;
            self.workSchedule.name = schedule.workScheduleName;
            self.workSchedule.workDay = schedule.workDay
                .split('')
                .map((i) => moment().weekday(i).format('ddd'))
                .join(', ');
            self.workSchedule.workingTime = this.convertWorkingTime(schedule);
            const workTime = moment(schedule.workTime, 'HHmm');
            self.workSchedule.workTime = {hours: workTime.format('HH'), minutes: workTime.format('mm')};
            self.workSchedule.dailyMaxMinutes = schedule.dailyMaxMinutes;
            self.workSchedule.weeklyTargetMinutes = schedule.weeklyTargetMinutes;
            

            // if (schedule.workScheduleType == 'SHIFT_TIME') {
            //     let shiftList = [];
            //     schedule.workScheduleShiftList.forEach((item) => {
            //         let shift = {};
            //         shift.startTime = moment(item.workStartTime, 'HHmm').format('HH : mm A');
            //         shift.endTime = moment(item.workEndTime, 'HHmm').format('HH : mm A');

            //         shiftList.push(shift);
            //     });

            //     self.workSchedule.shiftList = shiftList;
            // }
        },
        cancelEditJobInfo() {
            const self = this;

            self.request = JSON.parse(JSON.stringify(self.beforeEditData));
            self.errMsgReset();
            self.$nextTick(() => {
                self.nowEdit = false;
            });
        },
        saveJobInfo() {
            const self = this;

            self.errMsgReset();
            if (!self.isValidCheck()) {
                self.showNotiErr = true;
                return;
            }

            let {departmentSeq, jobTitleSeq, joinDate, workPlaceSeq, employeeId} = self.request;
            let isDepartmentManager = self.isHeadOfOrganition;
            const requestItem = {
                employeeSeq: self.request.employeeSeq,
                departmentSeq,
                jobTitleSeq,
                joinDate,
                workPlaceSeq,
                employeeId,
                probationEndDate: null,
                isDepartmentManager: isDepartmentManager,
                employmentType: self.request.employmentType,
            };

            const url = self.$api('uri', 'put-employee-job-info');
            self.$axios
                .put(url, requestItem)
                .then((res) => {

                    self.showNoti = true;
                    self.nowEdit = false;
                    self.$emit('afterSave');
                    self.getEmployeeJobInfo(self.request.employeeSeq);
                    self.currentDepartmentSeq = requestItem.departmentSeq;
                    self.isCurrentHead = self.isDepartmentManager;
                })
                .catch((err) => {
                    console.log(err.response);
                    if (err.response.data.code == 'HR_EMPLOYEE_UPDATE_500_FAILED_DUPLICATED_EMPLOYEE_ID') {
                        alert("Entered Employee ID No. is duplicated. Please enter other Employee ID No.");
                    }
                });
        },
        editButtonClick() {
            const self = this;
            self.beforeEditData = JSON.parse(JSON.stringify(self.request));
            self.nowEdit = true;
        },
        getPeriodFromJoined(joinDate) {
            if (!joinDate) {
                return;
            }

            const self = this;

            const originDate = moment(joinDate, 'YYYYMMDD');
            let currentDate = moment(self.lastWorkingDate, 'YYYYMMDD');
            let duration = moment.duration(currentDate.diff(originDate));

            let diffYear = duration.years();
            let diffMonth = duration.months();
            let diffDay = duration.days();

            self.period = {diffYear, diffMonth, diffDay};
        },
        addVacationSubmitRequestAfterConfirm() {
            const self = this;
            if (!self.isEmployeeStatusValid(self.popupItems)) {
                return;
            }

            const startDate = self.popupItems.employeeStatusStartDatetime;
            const endDate = self.popupItems.employeeStatusEndDatetime;
            const employeeSeq = self.selectedEmployeeSeq;

            const requestItem = {startDate, endDate, employeeSeq};

            // duplication check
            const url = self.$api('uri', 'post-check-period-duplication');
            self.$axios
                .post(url, requestItem)
                .then((res) => {
                    let dupList = res.data.data.list;

                    if (dupList == null || dupList.length == 0) {
                        self.saveEmployeeVacation();
                    } else {
                        alert('Date already has vacation.');
                    }
                })
                .catch((err) => {
                    console.log('fail: ', err);
                });
        },
        saveEmployeeVacation() {
            const self = this;

            //init
            let {
                employeeSeq,
                employeeStatus,
                employeeStatusContent,
                employeeStatusStartDatetime,
                employeeStatusEndDatetime,
                leaveName
            } = '';

            employeeSeq = ValidateUtil.checkIsEmptyChangeSpace(self.selectedEmployeeSeq);
            employeeStatus = 'ON_LEAVE';
            employeeStatusContent = ValidateUtil.checkIsEmptyChangeSpace(self.popupItems.employeeStatusContent);

            employeeStatusStartDatetime = self.popupItems.employeeStatusStartDatetime;
            employeeStatusEndDatetime = self.popupItems.employeeStatusEndDatetime;
            leaveName = self.popupItems.leaveName;

            //  조건검사
            if (employeeStatusStartDatetime == null) {
                alert('Please enter a valid start date');
                return;
            }

            if (employeeStatusEndDatetime == null) {
                alert('Please enter a valid end date');
                return;
            }

            if (employeeStatusStartDatetime > employeeStatusEndDatetime) {
                alert('Date input is incorrect. Please enter a valid date');
                return;
            }

            if (ValidateUtil.checkIsEmpty(employeeStatusContent) || ValidateUtil.checkIsEmpty(leaveName)) {
                alert('Notes can’t be blank');
                return;
            }

            var requestItem = {
                employeeSeq,
                employeeStatus,
                employeeStatusContent,
                employeeStatusStartDatetime,
                employeeStatusEndDatetime,
                leaveName,
            };

            const url = self.$api('uri', 'post-employee-status-history');
            self.$axios
                .post(url, requestItem)
                .then((res) => {
                    self.allClose();
                    self.getEmployeeJobInfo(self.selectedEmployeeSeq);
                    self.$emit('getHistory');
                    self.$emit('afterSave');
                })
                .catch((err) => {
                    console.log(err.response);
                });
        },
        resignedDuplicationCheck() {
            const self = this;
            const employeeSeq = self.selectedEmployeeSeq;

            const requestItem = {employeeSeq};
            // duplication check
            const url = self.$api('uri', 'post-check-resigned-duplication');
            self.$axios
                .post(url, requestItem)
                .then((res) => {
                    let dupList = res.data.data.list;

                    if (dupList == null || dupList.length == 0) {
                        self.saveEmployeeResignation();
                    } else {
                        alert('Already have Resigned information.');
                    }
                })
                .catch((err) => {
                    console.log('fail: ', err);
                });
        },
        saveEmployeeResignation() {
            const self = this;

            //init
            let employeeSeq = ValidateUtil.checkIsEmptyChangeSpace(self.selectedEmployeeSeq);
            let employeeStatus = 'RESIGNED';
            let employeeStatusContent = ValidateUtil.checkIsEmptyChangeSpace(self.popupItems.employeeStatusContent);
            let employeeResignationDate = self.popupItems.employeeResignationDate;
            let employeeResignationType = self.popupItems.employeeResignationType;

            if (employeeResignationDate == null) {
                alert('Please enter a valid Resigned date');
                return;
            }

            if (ValidateUtil.checkIsEmpty(employeeStatusContent)) {
                alert('Notes can’t be blank');
                return;
            }

            if (ValidateUtil.checkIsEmpty(employeeResignationType)) {
                alert('Resignation Type can’t be blank');
                return;
            }

            var requestItem = {
                employeeSeq,
                employeeStatus,
                employeeStatusContent,
                employeeResignationDate,
                employeeResignationType,
            };

            const url = self.$api('uri', 'post-employee-status-history');
            self.$axios
                .post(url, requestItem)
                .then((res) => {
                    self.allClose();
                    self.getEmployeeJobInfo(self.selectedEmployeeSeq);
                    self.$emit('getHistory');
                    self.$emit('afterSave');
                })
                .catch((err) => {
                    console.log(err.response);
                });
        },
        deleteAccount() {
            const self = this;
            self.editSaveEmployeeResigned();
            self.allClose();
        },
        editSaveEmployeeResigned() {
            const self = this;

            const employeeSeq = self.selectedEmployeeSeq;

            const url = self.$api('uri', 'put-employee-status-resignation').replace('{employeeSeq}', employeeSeq);
            self.$axios
                .put(url)
                .then((res) => {
                    self.allClose();
                    alert('The Resigned process has been completed.');
                    location.reload();
                })
                .catch((err) => {
                    console.log(err.response);
                });
        },
        clickPermanentlyDeleteButton() {
            const self = this;
            self.showDeleteEmployeeCheckPopup = true;
        },
        clickVacationButton() {
            const self = this;
            self.showVacationView = true;
            self.modalTitle = 'Indefinite Leave';
            //init
            self.popupItems = {};
            self.popupItems.pic = sessionStorage.getItem("pic");
        },
        clickResignationButton() {
            const self = this;
            self.PopupProfileInfo = true;
            self.showResignationView = true;

            //init
            self.popupItems = {};
            self.popupItems.pic = sessionStorage.getItem("pic");
        },
        changeDisable() {
            this.disableDeleteButton = !this.isDeleteEmployeeChecked;
        },
        handlePopupClose() {
            if (!this.showDeleteEmployeeCheckPopup) {
                this.isDeleteEmployeeChecked = false;
                this.disableDeleteButton = true;
            }
        },
        resetHeadCheckbox() {
            if (this.currentDepartmentSeq === this.request.departmentSeq) {
                this.isHeadOfOrganition = this.isCurrentHead;
                return;
            }
            this.isHeadOfOrganition = false;
        },
        checkDuplicateHead(isChecked) {
            if (!isChecked) {
                return;
            }

            const self = this;
            const url = self.$api('uri', 'get-department-head').replace('{departmentSeq}', self.request.departmentSeq);
            self.$axios
                .get(url)
                .then((res) => {
                    let departmentHeadSeq = null;
                    if (res.data.data != null) {
                        departmentHeadSeq = res.data.data.departmentManagerEmployeeSeq;
                    }

                    if (departmentHeadSeq === null || self.selectedEmployeeSeq === departmentHeadSeq) {
                        return;
                    }

                    // 이미 다른 head가 있을 경우
                    self.isHeadOfOrganition = false;
                    self.showHeadCheckPopup = true;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        displayResignationType(typeValue) {
            switch (typeValue) {
                case 'T':
                    return "Terminated/Resigned"
                case 'TR':
                    return "Transferred"
                case 'R':
                    return "Retirement"
                case 'D':
                    return "Death"
                default:
                    return '';
            }
        },
        convertWorkingTime(schedule){
            const wsType = schedule.workScheduleType;
            const period = (ws, we) => [this.convertDateTime(ws), this.convertDateTime(we)].join(' - ');
            if(wsType == 'FIXED_TIME'){
                const {workStartTime, workEndTime} = schedule;
                return [period(workStartTime, workEndTime)];
            }

            if(wsType == 'SHIFT_TIME' && schedule?.workScheduleShiftList){
                const shifts = schedule.workScheduleShiftList;
                return shifts.map(({workStartTime,workEndTime})=> period(workStartTime, workEndTime));
            }

            if(wsType == 'FLEXI_TIME'){
                const { windowStartTime, windowEndTime } = schedule;
                const widonwTimeStr = period(windowStartTime, windowEndTime);
                return [`${widonwTimeStr}`];
            }
            return [];
        },
        convertDateTime(timeStr) {
            if (!timeStr) return;

            return moment(timeStr, 'HHmm').format('HH : mm A');
        },
        formatDuration(minutes, hUnit = 'H', mUnit = 'M', usePlural = false) {
            if (minutes < 0 || !Number.isFinite(minutes)) {
                return "";
            }

            if(minutes==0){
                return `0 ${mUnit}`;
            }

            const totalMins = Math.floor(minutes);
            const hours = Math.floor(totalMins / 60);
            const mins = totalMins % 60;
            const pluralize = (n, unit) => usePlural ? `${n}${unit}${n !== 1 ? "s" : ""}` : `${n}${unit}`;

            return [
                hours && pluralize(hours, hUnit),
                mins && pluralize(mins, mUnit),
            ]
                .filter(Boolean)
                .join(' ');
		},
    },
};
</script>
